exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cls-1 {\n    fill: url(#radial-gradient);\n}\n.cls-2 {\n    fill: #78be20;\n}\n.cls-3 {\n    fill: #3c864d;\n    opacity: 0.3;\n}\n.cls-4 {\n    fill: #fff;\n}\n", ""]);

// exports
